<template>
  <div class="survey-view-images" v-if="surveyDoc" v-loading="surveyDoc._id === ''">
    <h5><strong> Imagens </strong></h5>
    <a v-if="surveyDoc._id !== ''" v-for="(image, index) in images" :key="index" :href="`${host}/${db}/${surveyDoc._id}/${image}.jpg`" target="_blank">
      <img :src="`${host}/${db}/${surveyDoc._id}/${image}.jpg`" class="image-survey" :alt="image">
    </a>
  </div>
  <div v-else><p>Nenhuma imagem encontrada para esta pesquisa</p></div>
</template>
<script>
import Couchdb from 'src/services/Couchdb'
export default {
  name: 'survey-view-images',

  props: ['survey'],

  data () {
    return {
      images: [ 'body', 'coil', 'compartments', 'customer', 'doors', 'engine', 'rubber', 'sealingNumber' ],
      surveyDoc: { _id: '' }
    }
  },

  computed: {
    host () {
      return process.env.DB_SURVEYS_DOCS_HOST
    },

    db () {
      return process.env.DB_SURVEYS_DOCS_NAME
    }
  },

  mounted () {
    Couchdb.connection('surveys_docs').where('surveyId', this.survey._id).get().then(res => {
      console.log(res)
      this.surveyDoc = res[0]
    })
  }
}
</script>
<style scoped>
.image-survey {
  max-height: 200px;
  margin: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Surveys/SurveyViewImages.vue